<template>
  <VLayout>
    <template slot="title-header">
      <VMainTitle>
        <template slot="title">
          <i18n path="importmedicineshome.title" tag="span">
            <span place="country_name"><VCountryName :iso="deviceCountry" /></span>
          </i18n>
        </template>
      </VMainTitle>
    </template>
    <b-container class="ml-0 pl-0">
      <b-row>
        <b-col cols="12">
          <div class="align-middle">
            <flag :iso="deviceCountry" :squared="false" style="font-size: 3rem" />
            <VCountryName :iso="deviceCountry" class="ml-2" />
          </div>
        </b-col>
      </b-row>
    </b-container>

    <h4 class="text-uppercase mt-5">
      {{ $t('importmedicineshome.import_to_home_title') }}
    </h4>
    <p class="mt-3">{{ $t('importmedicineshome.explain_text') }}</p>
    <p class="mt-4">{{ $t('importmedicineshome.steps_intro_text') }}</p>
    <div class="bg-light2 shadow-sm p-4">
      <b-container>
        <b-row>
          <b-col>
            <p class="pt-2 pb-2"><span class="h4 font-weight-bold">1º</span> {{ $t('importmedicineshome.step1_text') }}</p>
            <p class="pt-2 pb-2"><span class="h4 font-weight-bold">2º</span> {{ $t('importmedicineshome.step2_text') }}</p>
            <p class="pt-2 pb-2"><span class="h4 font-weight-bold">3º</span> {{ $t('importmedicineshome.step3_text') }}</p>
          </b-col>
          <b-col>
            <p class="pt-2 pb-2"><span class="h4 font-weight-bold">4º</span> {{ $t('importmedicineshome.step4_text') }}</p>
            <p class="pt-2 pb-2"><span class="h4 font-weight-bold">5º</span> {{ $t('importmedicineshome.step5_text') }}</p>
            <p class="pt-2 pb-2"><span class="h4 font-weight-bold">6º</span> {{ $t('importmedicineshome.step6_text') }}</p>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <p class="mt-5">{{ $t('importmedicineshome.post_steps_text') }}</p>

    <VButtonGroup
      :primary_to="{name: 'importmedicinesform'}"
      :primary_text="$t('importmedicineshome.continue_button')"
      hide_secondary
      end
    />

  </VLayout>
</template>


<script>
import { mapGetters } from "vuex";
import VLayout from "@/layouts/Default";
import VCountryName from "@/components/VCountryName";
import VButtonGroup from "@/components/VButtonGroup";
import VMainTitle from "@/components/VMainTitle";

export default {
  name: "import-medicines-home",
  components: {
    VLayout,
    VCountryName,
    VButtonGroup,
    VMainTitle,
  },
  computed: {
    ...mapGetters("auth", ["deviceCountry"]),
  },
  data() {
    return {};
  },
  fallbackI18n: {
    messages: {
      und: {
        importmedicineshome: {
          title: "Import of medicines to {country_name}",
          import_to_home_title:
            "Import the medication you need from the comfort of your home",
          intro_text: "",
          breadcrumb: "Import of medicines",
          explain_text:
            "Medicines not available in your country are called 'orphans' or 'compassionate uses' as they are intended for the treatment of rare or rare diseases and need to be imported through a regulatory authorization process.",
          steps_intro_text: "To begin the process, all you need is:",
          post_steps_text:
            "If you need support to complete the process, receive our personalized advice and we will accompany you during the process.",
          continue_button: "Continue",
          step1_text:
            "Download and follow the 'Import Guide' available for your country.",
          step2_text:
            "Gather the documentation required by the local government agency.",
          step3_text:
            "Download, fill out and upload the documentation to our platform.",
          step4_text: "Select the medication to import",
          step5_text:
            "Select where you want to receive your medicine, make your payment and go!",
          step6_text:
            "Your application will be received by the government agency, which will issue an authorization certificate so you can receive your medication.",
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
.bg-light2 {
  background-color: #f9f9f9;
}
</style>

